import { render, staticRenderFns } from "./confirmdelete.vue?vue&type=template&id=0b4d7321&scoped=true&"
import script from "./confirmdelete.vue?vue&type=script&lang=js&"
export * from "./confirmdelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d7321",
  null
  
)

export default component.exports